import { useDebounceCallback } from '@react-hook/debounce';
import { useEffect } from 'react';

const useSupportedCols = ({ tableSortBy, tableType }) => {
  const checkSupportedCols = useDebounceCallback(() => {
    const supportedSortableCols = tableType.sortBy.supportedCols;
    const isSortKeyNotSupported = !supportedSortableCols.includes(
      tableSortBy.key
    );
    if (isSortKeyNotSupported) {
      tableSortBy.onChange(tableType.sortBy.default);
    }
  }, 300);

  useEffect(() => {
    checkSupportedCols();
  }, [tableType]);
};

export default useSupportedCols;
